import { render, staticRenderFns } from "./fenceAlarm.vue?vue&type=template&id=684abd3a&scoped=true"
import script from "./fenceAlarm.vue?vue&type=script&lang=js"
export * from "./fenceAlarm.vue?vue&type=script&lang=js"
import style0 from "./fenceAlarm.vue?vue&type=style&index=0&id=684abd3a&prod&lang=scss"
import style1 from "./fenceAlarm.vue?vue&type=style&index=1&id=684abd3a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "684abd3a",
  null
  
)

export default component.exports